import React from 'react';
import { connect } from 'react-redux';
import { AppDispatch } from 'reducers/index';

import { hideModal } from 'cards/actions/modalActions';

import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import { CircleIcon } from '@zola/zola-ui/src/components/CircleIcon';
import { LightBulb2 } from '@zola/zola-ui/src/assets/images/icons';

import styles from './styles.module.less';

export type DigitalExpiryInfoModalProps = {
  onConfirm: () => void;
};

const DigitalExpiryInfoModal = ({ onConfirm }: DigitalExpiryInfoModalProps): JSX.Element => (
  <div className={`${styles.container} ${styles.expiryContainer}`}>
    <CircleIcon image={LightBulb2} size={100} variant="cream" />
    <div className={styles.header}>
      Your digital save the date expires 6 months after it’s published
    </div>
    <div className={styles.content}>
      <div>
        This gives guests plenty of time to note your date and receive a follow-up invitation.
        Date’s changing? Return any time before the card expires to renew it for another 6 months.
      </div>
    </div>
    <div className={styles.buttonContainer}>
      <ButtonV2 onClick={onConfirm}>Got It</ButtonV2>
    </div>
  </div>
);

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  onConfirm: () => dispatch(hideModal()),
});

export default connect(null, mapDispatchToProps)(DigitalExpiryInfoModal);
